<template>
  <div
    ref="mapEl"
    class="map"
    style="height: 50vh; max-height: 475px; width: 100%"
  >
    <template v-if="isMobile">
      <div class="swipe-layer">
        <span class="text-center"
          >Dotknij dwoma palcami, aby przesuwać mapę.</span
        >
      </div>
    </template>
    <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 50vh; max-height: 475px"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="withPopup">
        <l-popup v-if="hotelName">
          <div @click="innerClick">{{ getHotelName() }}</div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "T1Map",
  props: {
    mapCoords: Array,
  },
  data: () => ({
    zoom: 13,
    zoomLevel: 3,
    center: latLng(47.41322, -1.219482),
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    withPopup: latLng(47.41322, -1.219482),
    withTooltip: latLng(47.41422, -1.250482),
    currentZoom: 13,
    currentCenter: latLng(47.41322, -1.219482),
    showParagraph: false,
    mapOptions: {
      zoomSnap: 0.5,
    },
    lat: "",
    lng: "",
    hotelName: "",
    typMapy: "",
    isMobile: isMobile,
  }),
  methods: {
    getMapCenter() {
      let coords = latLng(this.lat, this.lng);

      if (this.lat != "" && this.lng != "") {
        this.centerUpdate(coords);
        this.popUpdate(coords);
        this.center = coords;
        this.withTooltip = coords;
      }
    },
    popUpdate(center) {
      this.withPopup = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    getHotelName() {
      return this.hotelName;
    },
    innerClick() {
      window.open(
        "http://maps.google.com/maps?q=LocationName@" +
          this.lat +
          "," +
          this.lng +
          "&amp;iwloc=" +
          escape(this.hotelName),
        "HotelAtGoogleMap"
      );
    },
    setCurrentCoords() {
      if (this.mapCoords && this.mapCoords[0]) {
        if (this.mapCoords[0].lat) {
          this.lat = this.mapCoords[0].lat;
        }
        if (this.mapCoords[0].lng) {
          this.lng = this.mapCoords[0].lng;
        }
        if (this.mapCoords[0].hotelName) {
          this.hotelName = this.mapCoords[0].hotelName;
        }
        if (this.mapCoords[0].zoom) {
          this.zoom = Number(this.mapCoords[0].zoom);
        }
        if (this.mapCoords[0].typ) {
          this.typMapy = this.mapCoords[0].typ;
        }
        if (this.lat != "" && this.lng != "") {
          this.getMapCenter();
        }
      }
    },
    onTwoFingerDrag(e) {
      if (e.type === "touchstart" && e.touches.length === 1) {
        e.currentTarget.classList.add("swiping");
      } else {
        e.currentTarget.classList.remove("swiping");
      }
    },
  },
  watch: {
    mapCoords: function () {
      this.setCurrentCoords();
    },
  },
  mounted() {
    this.setCurrentCoords();

    if (this.isMobile) {
      const mapEl = this.$refs.mapEl;
      mapEl.addEventListener("touchstart", this.onTwoFingerDrag, {
        passive: true,
      });
      mapEl.addEventListener("touchend", this.onTwoFingerDrag, {
        passive: true,
      });
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
};
</script>

<style lang="scss" scoped>
.map {
  position: relative;

  .swipe-layer {
    background-color: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    opacity: 0;
    padding: 32px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 0.15s ease-in-out;
    z-index: 999;
  }

  &.swiping {
    .swipe-layer {
      background-color: rgba(0, 0, 0, 0.45);
      opacity: 1;
      pointer-events: none;
    }
  }
}
</style>
